import { render, staticRenderFns } from "./DoctorPreferenceSelect.vue?vue&type=template&id=9224479e"
import script from "./DoctorPreferenceSelect.vue?vue&type=script&lang=js"
export * from "./DoctorPreferenceSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports